import { Controller } from '@hotwired/stimulus';
import GLightbox from 'glightbox';

type LightboxInstance = ReturnType<typeof GLightbox>;

export default class extends Controller<HTMLElement> {
    static values = {
        allowLightbox: Boolean,
        selector: { type: String, default: '.glightbox3' },
        loopable: { type: Boolean, default: true },
        zoomable: { type: Boolean, default: false }
    };

    protected lightbox: LightboxInstance | null = null;

    connect(): void {
        if (this.allowLightboxValue) {
            this.initializeLightbox();
        }
    }

    private initializeLightbox(): void {
        this.lightbox = GLightbox({
            selector: this.selectorValue,
            loop: this.loopableValue,
            zoomable: this.zoomableValue
        });
    }

    disconnect(): void {
        this.lightbox?.destroy();
        this.lightbox = null;
    }

    declare readonly allowLightboxValue: boolean;
    declare readonly selectorValue: boolean;
    declare readonly loopableValue: boolean;
    declare readonly zoomableValue: boolean;
}